/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "494394e8b0c4b45c596067631bd13207fa636a55";
